// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"7c0b021f","239":"3c473eaf","644":"d042b348"}[chunkId] + ".chunk.js";
};